import {
  AppLayout,
  AppLayoutProps,
  Box,
  ColumnLayout,
  Container,
  ContentLayout,
  Grid,
  Header,
  Link,
  SpaceBetween,
  TextContent,
  Badge,
  Button,
  Tabs,
  Textarea,
  Table,
  CollectionPreferences,
  TextFilter,
  Pagination,
  SegmentedControl,
} from "@cloudscape-design/components";
import { useEffect, useState, useContext } from "react";
import { GlobalContext, ContentContext } from "../../../context";
import { link } from "fs";
import ResultsTable from "../../../components/results-table/results-table";
import useAxios, {
  configure,
  loadCache,
  serializeCache,
  makeUseAxios,
} from 'axios-hooks'
import { leagueId, apiKey, baseUrl } from '../../../leagueId';
import * as awsui from "@cloudscape-design/design-tokens";
import { CustomButton } from "../../../components/buttons";
import { useNavigate, useLocation } from "react-router-dom";
import { navigateFn } from "../../../routingHelper";
import { useAuthenticator } from '@aws-amplify/ui-react';
import { useMediaQuery } from 'react-responsive';


const axiosHeaders = { 
  "api-key": apiKey, 
  "Content-Type": "application/json",
}

const sortItems = (items:any) => {  
  if (items !== undefined){
    const sortedItems = items.sort((a:any, b:any) => {
      if (a.name < b.name) return 1;
    })
    return sortedItems
  }
  return items
}

const resultsTableColumns = [
  "position",
  "userName",
  "fastestTime",
]


export default function Qualifying() {
  const navigate = navigateFn({
    navigate: useNavigate(),
    location: useLocation(),
  })
  const location = useLocation();
  const { 
    userAttributes, setUserAttributes,
    seriesContent, setSeriesContent,
  } = useContext(GlobalContext);

  const { user, signOut } = useAuthenticator((context) => [context.user]);
  const { route } = useAuthenticator(context => [context.route]); 
  const { authStatus } = useAuthenticator(context => [context.authStatus]); 

  const [ seriesId, setSeriesId ] = useState<string>("01H51VP9QX6TDT5W097GACKS33");
  const [ seasonId, setSeasonId ] = useState<string>("01H5YTBQBXQ52BWZZVSG2SFD1X");
  const [ roundId, setRoundId ] = useState<string>("01H5YTCZD9P8DFDKAXKQJB720Q");
  const [ raceId, setRaceId ] = useState<string>();
  const [ sessionName, setSessionName ] = useState<string>();
  const [ irSessionId, setIrSessionId ] = useState<number>();
  const [ irSubSessionId, setIrSubSessionId ] = useState<number>();
  const [ country , setCountry ] = useState<string>();

  const screenWidth_600 = useMediaQuery({query: "only screen and (max-width : 600px)"})
  const screenWidth_800 = useMediaQuery({query: "only screen and (max-width : 800px)"})
  const screenWidth_1000 = useMediaQuery({query: "only screen and (max-width : 1000px)"})

  const [{ data: subSessionResults = [], loading: subSessionResultsLoading, error: subSessionResultsError}, getSubSessionResults] = useAxios({
    url: baseUrl + "/subsession_results",
    method: "get",
    headers: axiosHeaders,
    params: {
      leagueId: leagueId,
      seriesId: seriesId,
      seasonId: seasonId,
      roundId: roundId,
      raceId: raceId,
      irSessionId: irSessionId,
      irSubSessionId: irSubSessionId,
      sessionName: sessionName
    },
  }, {
    manual: true,
  });


  const [{ data: seriesDriver, loading: seriesDriverLoading, error: seriesDriverError}, getSeriesDriver] = useAxios({
    url: baseUrl + "/series-driver",
    method: "get",
    headers: axiosHeaders,
    params: {
      method: "get",
      leagueId: leagueId,
      seriesId: seriesId,
      driverId: userAttributes["custom:leagueDriverId"],
    },
  }, {
    manual: true,
  });

  useEffect(() => {
    getSeriesDriver()
  }, [])

  // useEffect(() => {
  //   if (subSessionResults !== undefined && subSessionResults.length > 0){
  //     console.table(subSessionResults)
  //   }
  // }, [subSessionResults])


  useEffect(() => {
    if (seriesDriver){
      setCountry(seriesDriver.country ? seriesDriver.country : "")
    }
  }, [seriesDriver])

  useEffect(() => {
    if (country === "Australia") {
      setRaceId("01H600A8H9PN7W8VC9CF9DQMMC")
      // setIrSessionId(211438527)
      // setIrSubSessionId(62764654)
    }
    console.log('get results')
    // getSubSessionResults()
  }, [country])


  const password = () => {
    if (country === "United Kingdom") return "Py2dlFKW";
    if (country === "New Zealand") return "gQdCM1dR";
    if (country === "Australia") return "trjB6cW5";
  }

  const timeZone = () => {
    if (country === "United Kingdom") return "BST";
    if (country === "New Zealand") return "NZST";
    if (country === "Australia") return "AEST";
  }


  const CheckRegisteredDriver = () => {
    if (seriesDriver) return (
      <>
        <div style={{width: "100%", paddingTop: "20px"}}>
          <div className="body-content" style={{maxWidth: "800px"}}>   
            <div style={{display: "flex", flexDirection: "row", marginBottom: "20px", justifyContent: "space-between"}}>
              <div style={{display: "flex", flexDirection: "column", textAlign: "left", gap: "10px"  }}>
                <p>You are registered for this event as a driver for {country}.</p>
                <p>To qualify, go to the Hosted section in iRacing to find your server.</p>
              </div>
            </div>
          </div>
        </div>
        <div style={{width: "100%", background: awsui.colorBackgroundButtonPrimaryActive, color: awsui.colorTextButtonPrimaryActive, padding: "10px 0px 10px 0px"}}>
          <div className="body-content" style={{maxWidth: "800px"}}>   
            <div style={{display: "flex", flexDirection: "column", textAlign: "left", gap: "10px" }}>
              <p><b>Server name:</b> TRI-NATIONS - {country} qualifying.</p> 
              <p><b>Password:</b> {password()}</p>
              <p><b>Dates:</b> July 23, July 30</p>
              <p><b>Start time:</b> 9 am {timeZone()}</p> 
            </div>
          </div>
        </div>
        <div style={{width: "100%", paddingTop: "30px", paddingBottom: "50px", background: "#dddddd", color: awsui.colorTextButtonNormalActive}}>
          <div className="body-content" style={{maxWidth: "800px" }}>   
            <div style={{display: "flex", width: "100%", fontSize: "2rem", fontWeight: "bold", paddingBottom: "20px"}}>
              Qualifying Results
            </div>
            { ResultsTable(sortItems(subSessionResults), resultsTableColumns, subSessionResultsLoading) }
          </div>
        </div>
      </>
    )
    return (
      <>
        <div style={{width: "100%", background: awsui.colorBackgroundItemSelected, padding: "50px"}}>
          <div className="body-content">
            <Box textAlign="center">
              <div style={{padding: "20px", fontSize: "22px"}}>
                You are not registered for this event. 
              </div>
              <Link 
                onFollow={ (event) => {
                  event.preventDefault();
                  setSeriesContent("register")
                  if (route !== 'authenticated') {
                    navigate("/signin")
                  }
                }}
              >
                <CustomButton
                  type="button"
                  onMouseEnter={ (event:any) => {
                    event.currentTarget.style.filter = `hue-rotate(110deg)`;
                  }}
                  onMouseLeave={ (event:any) => {
                    event.currentTarget.style.filter = "none";
                  }}
                  style={{
                    height: "80px", 
                    width: "50%", 
                    minWidth: "200px",
                    background: awsui.colorBackgroundNotificationRed, 
                    borderRadius: "2px", 
                    alignItems: "center", 
                    color: "white", 
                    fontWeight: "normal", 
                    fontSize: screenWidth_800 ? "24px" : "32px", 
                    borderWidth: "0",
                    lineHeight: "35px",
                  }}
                >
                  REGISTER NOW
                </CustomButton>
              </Link>
            </Box>
          </div>
        </div>
      </>
    )
  }

  return (
    <>
      <center>
        <CheckRegisteredDriver />
      </center>
    </>
  )
}
